/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/10/21
 */

import { createIcon } from '@chakra-ui/react';
import React from 'react';
import svgIcons from '@/assets/icons';

type SVGComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string | undefined }>;

type SVGToIcon<T> = {
    [K in keyof T]: ReturnType<typeof createIcon>;
};

const toIcons = <T extends Record<string, SVGComponent>>(icons: T): SVGToIcon<T> => {
    return Object.fromEntries(
        Object.entries(icons).map(([name, Icon]) => {
            return [
                name,
                createIcon({
                    displayName: name,
                    path: <Icon fill="currentColor" role="presentation" />,
                }),
            ];
        }),
    ) as SVGToIcon<T>;
};

const Icons = toIcons(svgIcons);
export default Icons;
